module.exports = __webpack_public_path__ + "0bbab28c0a64998bd5f5b3903c06cec2.svg";